<mat-card *ngIf="!loading" class="mcd-card">
  <mat-card-header class="mcd-card-header">
    <mat-card-title class="mcd-card-title"
      >Manage Market Suppliers</mat-card-title
    >
  </mat-card-header>
  <div class="breadcrumbs clearfix">
    <div class="breadcrumbs-inner">
      <ul>
        <li *ngIf="userRole == this.userRoleEnum.MarketAdmin">
          <a routerLink="/market-admin-panel" routerLinkActive="active"
            >Market Admin Panel</a
          >
        </li>
        <li *ngIf="userRole == this.userRoleEnum.AOWAdmin">
          <a routerLink="/market-admin-panel" routerLinkActive="active"
            >Segment Lead Panel</a
          >
        </li>
        <li class="separator">></li>
        <li class="active">Manage Market Suppliers</li>
      </ul>
    </div>
  </div>
  <mat-card-content class="mcd-card-content">
    <div class="row">
      <div class="col-6">
        <div>
          <mat-form-field>
            <input
              matInput
              placeholder="Search by Name or Description"
              value="{{ searchKey }}"
              (keyup.enter)="addSearchKey(key)"
              name="search"
              #key
            />
            <button
              mat-button
              *ngIf="searchKey"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="searchKey = ''; addSearchKey(searchKey)"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </div>
        <div *ngIf="supplierList.globalMarketSuppliers.length > 0">
          <mat-form-field>
            <mat-select
              [value]="pageSize"
              name="nOfRows"
              #items
              (selectionChange)="selectedItemsPerPageChange(items)"
            >
              <mat-option [value]="item.value" *ngFor="let item of pageSizes">
                {{ item.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div class="col-6 text-right" *ngIf="canAddNationalSupplier">
        <div>
          <button
            class="mcd-btn mcd-btn-secondary"
            mat-raised-button
            (click)="onAddEditNationalSupplier()"
          >
            Add Supplier
          </button>
        </div>
        <div *ngIf="this.userRole == 1 || this.userRole == 4">
          <mat-form-field class="float-right">
            <mat-label>Country</mat-label>
            <mat-select
              name="dropCategory"
              [value]="selectedCountryId"
              #country
              (selectionChange)="selectCountry(country)"
            >
              <mat-option
                *ngFor="let item of countries; let j = index"
                [value]="item.id"
                >{{ item.name }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div
      class="table-wrapper"
      *ngIf="supplierList.globalMarketSuppliers.length > 0"
    >
      <table class="table nrbes-grid">
        <thead class="thead-light">
          <tr>
            <th scope="col" width="10%">Logo</th>
            <th scope="col" width="15%">Name</th>
            <th scope="col" width="67%">Description</th>
            <th scope="col" width="8%">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let item of supplierList.globalMarketSuppliers"
            (click)="rowSelected(item)"
          >
            <td class="title-cell">
              <div class="mcd-supplier-logo">
                <img
                  [src]="item?.supplier?.supplierLogoAttachment?.image"
                  class="img-fluid"
                />
              </div>
            </td>
            <td class="location-cell">{{ item.supplier.name }}</td>
            <td class="description">
              <span title="{{ item.supplier.description }}" class="description">
                {{ item.supplier.description }}
              </span>
            </td>
            <td>
              <div class="row grid-actions hide-sm">
                <div
                  class="col-6"
                  *ngIf="
                    canDeleteNationalSupplier && item.supplier.isGlobal == false
                  "
                >
                  <a
                    class="action-controls"
                    (click)="openDeleteModal(item, $event)"
                    routerLinkActive="active"
                    title="clear"
                    ><i class="material-icons"> clear </i></a
                  >
                </div>
                <div
                  class="col-6"
                  *ngIf="
                    canDeleteNationalSupplier && item.supplier.isGlobal == false
                  "
                >
                  <a
                    class="action-controls"
                    (click)="onAddEditNationalSupplier(item.supplier.id)"
                    routerLinkActive="active"
                    title="Edit"
                    href="javascript:void(0);"
                    ><i class="material-icons"> create </i></a
                  >
                </div>
              </div>

              <a
                (click)="actionMenuOpen($event)"
                class="mcd-more-btn show-sm"
                [matMenuTriggerFor]="menu"
                href="javascript:void(0);"
              >
                <i class="material-icons">more_vert</i>
              </a>
              <mat-menu #menu="matMenu" overlapTrigger="false">
                <span>
                  <button
                    *ngIf="
                      canEditNationalSupplier && item.supplier.isGlobal == false
                    "
                    mat-menu-item
                    (click)="onAddEditNationalSupplier(item.supplier.id)"
                  >
                    Edit
                  </button>
                  <button
                    *ngIf="
                      canDeleteNationalSupplier &&
                      item.supplier.isGlobal == false
                    "
                    mat-menu-item
                    (click)="closeMatMenuAndOpenDeleteModal(item, $event)"
                  >
                    Remove
                  </button>
                </span>
              </mat-menu>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="row">
        <div class="col">
          <ngb-pagination
            class="float-right"
            [(page)]="page"
            [pageSize]="pageSize"
            [maxSize]="4"
            [rotate]="true"
            [ellipses]="true"
            [collectionSize]="collectionSize"
            (pageChange)="getSuppliers()"
          ></ngb-pagination>
        </div>
      </div>
    </div>
    <div *ngIf="supplierList.globalMarketSuppliers.length == 0">
      No results found based on search terms.
    </div>
  </mat-card-content>
</mat-card>
<app-mcd-loader class="mcd-page-loader" *ngIf="loading"></app-mcd-loader>
